import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesBadgeVariables = theme => ({
  height: theme.height.xxxsmall
});
export const StylesBadgeBase = theme => ({
  background: theme.color.light.base,
  border: theme.border.base,
  borderRadius: theme.borderRadius.base,
  color: theme.fontColor.muted,
  cursor: 'default',
  display: 'inline-flex',
  alignItems: 'center',
  padding: "0 " + theme.space.small + "px",
  lineHeight: '1',
  fontSize: theme.fontSize.xsmall,
  fontFamily: theme.fontFamily.heading,
  fontWeight: theme.fontWeight.bold,
  letterSpacing: theme.letterSpacing.small,
  height: StylesBadgeVariables(theme).height,
  textAlign: 'center',
  textTransform: 'uppercase',
  userSelect: 'none'
});
export const StylesBadgeSecondary = theme => ({
  borderColor: theme.fontColor.base,
  background: theme.fontColor.base,
  color: theme.contrast.base
});
export const StylesBadgePrimary = theme => ({
  borderColor: theme.color.primary.base,
  background: theme.color.primary.base,
  color: theme.contrast.base
});
export const StylesBadgeDanger = theme => ({
  borderColor: theme.color.danger.base,
  background: theme.color.danger.base,
  color: theme.contrast.base
});
export const StylesBadgeRounded = theme => ({
  borderRadius: theme.borderRadius.rounded
});

const Badge = _ref => {
  let {
    className,
    children,
    rounded,
    type
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "children", "rounded", "type"]);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: [StylesBadgeBase(theme), type === 'primary' && StylesBadgePrimary(theme), type === 'danger' && StylesBadgeDanger(theme), type === 'secondary' && StylesBadgeSecondary(theme), rounded && StylesBadgeRounded(theme), process.env.NODE_ENV === "production" ? "" : ";label:Badge;"],
    className: clsx('CK__Badge', className)
  }, rest), children);
};

export default Badge;